// src/components/ResetPassword.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../styles/resetpassword.css";
import useBackend from "../hooks/useBackend";

import petfamLogo from "../assets/Petfamp.png";
import catReset from "../assets/cat-reset.webp";

export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const { post, loading } = useBackend();

  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Leer token desde URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const t = params.get("token");
    setToken(t || "");
    if (!t) {
      setError("El enlace para restablecer tu contraseña no es válido.");
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!password || !confirm) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    if (password.length < 8) {
      setError("La contraseña debe tener mínimo 8 caracteres.");
      return;
    }

    if (password !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    try {
      await post("/auth/reset-password", "", {
        token,
        newPassword: password,
      });

      setSuccess("Tu contraseña fue cambiada correctamente.");
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (err) {
      setError(
        err?.userMessage ||
          "No fue posible restablecer la contraseña. Intenta nuevamente."
      );
    }
  };

  return (
    <div className="rp-shell">
      {/* Columna izquierda */}
      <div className="rp-left">
        <div className="rp-card">
          {/* LOGO */}
          <div className="rp-logo-box">
            <img src={petfamLogo} alt="Petfam" />
          </div>

          <h2 className="rp-title">Restablecer contraseña</h2>
          <p className="rp-subtitle">
            Crea una nueva contraseña para tu cuenta.
          </p>

          {error && <div className="rp-alert rp-alert--error">{error}</div>}
          {success && <div className="rp-alert rp-alert--success">{success}</div>}

          {!success && (
            <form className="rp-form" onSubmit={handleSubmit}>
              <label>
                Nueva contraseña
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Mínimo 8 caracteres"
                  disabled={loading || !token}
                />
              </label>

              <label>
                Confirmar contraseña
                <input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Repite tu contraseña"
                  disabled={loading || !token}
                />
              </label>

              <button
                className="rp-btn-primary"
                type="submit"
                disabled={loading || !token}
              >
                {loading ? "Guardando..." : "Cambiar contraseña"}
              </button>

              <Link to="/login" className="rp-back">
                Volver a iniciar sesión
              </Link>
            </form>
          )}
        </div>
      </div>

      {/* Columna derecha */}
      <div className="rp-right">
        <img src={catReset} alt="" className="rp-cat" />
      </div>
    </div>
  );
}
